// useDefaultNodeOpen.js

import { useCallback } from 'react';
import useNodeOpenIntent from 'views/hooks/useNodeOpenIntent';

/**
 * useDefaultNodeOpen
 *
 * Default open for list/table/board clicks. Uses Peek unless the type has
 * Show Peek on open turned off (then Workspace). Expand also via Peek "Open".
 */
const useDefaultNodeOpen = () => {
    const { openNode } = useNodeOpenIntent();

    return useCallback((node) => {
        if (!node?.key) return;
        openNode(node);
    }, [openNode]);
};

export default useDefaultNodeOpen;
